import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { TextField } from '@deal/components';
import { NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement } from '../../../../generated/types.js';
import isValidNumber from '../isValidNumber.js';

var Generic = function Generic(_ref) {
  var question = _ref.question,
      disabled = _ref.disabled,
      numericValue = _ref.numericValue,
      onValueChanged = _ref.onValueChanged,
      fieldError = _ref.fieldError;

  var _a, _b, _c;

  var genericRenderingStyle = question.numericRenderingStyle;
  var decimalLength = (_a = genericRenderingStyle.decimalEntry) === null || _a === void 0 ? void 0 : _a.limitToScale;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      errorText = _useState2[0],
      setErrorText = _useState2[1];

  return React.createElement(React.Fragment, null, React.createElement(TextField, {
    label: "",
    labelHidden: true,
    disabled: disabled,
    error: !!errorText || fieldError,
    errorText: errorText,
    value: numericValue,
    autoFocus: false,
    type: "tel",
    placeholder: (_b = genericRenderingStyle.placeholder) === null || _b === void 0 ? void 0 : _b.plainText,
    unit: (_c = genericRenderingStyle.unit) === null || _c === void 0 ? void 0 : _c.plainText,
    unitPlacement: genericRenderingStyle.unitPlacement === NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement.LEFT ? 'left' : 'right',
    onChange: function onChange(event) {
      /**
       * Initially check that is even a valid number
       */
      if (!isValidNumber(event.target.value)) {
        setErrorText('Enter a valid number');
      } else {
        setErrorText(undefined);
      }
      /**
       * We use `limitToScale` to determine how many decimal points we go. If the value is null, we
       * assume it's an integer. The `toFixed` method stringifies the value regardless of the number
       * of the fractionDigits we go.
       */


      var doesIncludeDecimal = event.target.value.includes('.');

      if (decimalLength && doesIncludeDecimal) {
        var decimalValues = event.target.value.split('.')[1];

        if (decimalValues.length > decimalLength) {
          setErrorText("You can only use ".concat(decimalLength, " decimal places "));
        } else {
          setErrorText(undefined);
        }
      }

      onValueChanged(event.target.value);
    }
  }));
};

export default Generic;
//# sourceMappingURL=index.js.map
